import { SET_AWAITING_ORDER_ITEMS, SET_LIST_CE_PRODUCT_RPT, SET_SUBSCRIBER_ORDERS_USER } from './action';

const INITIAL_STATE = null;

const INITIAL_CE_RPT_CHECKOUT = {
     listCeProductRPT: [],
};

const ordersUserReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_ORDERS_USER: {
               return { ...state, orders: action.payload };
          }

          default:
               return state;
     }
};

export const checkoutCeProductRPT = (state = INITIAL_CE_RPT_CHECKOUT, action) => {
     switch (action.type) {
          case SET_LIST_CE_PRODUCT_RPT:
               return { ...state, listCeProductRPT: action.payload };
          default:
               return state;
     }
};

export const awaitingOrderItemsReducer = (state = [], action) => {
     switch (action.type) {
          case SET_AWAITING_ORDER_ITEMS:
               return action.payload;
          default:
               return state;
     }
};

export default ordersUserReducer;
